import { Component, OnInit, Input } from '@angular/core';
import { Location } from '@angular/common';
import { environment } from 'src/environments/environment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ImageModalComponent } from 'src/app/components/core/image-modal/image-modal.component';
import { VisitGpsModalComponent } from './visit-gps-modal/visit-gps-modal.component';
import { ActivatedRoute, Data } from '@angular/router';
import { HandsprayVisitDetail } from 'src/app/models/handspray.model';

@Component({
  selector: 'app-handspray-visit',
  templateUrl: './handspray-visit.component.html',
  styleUrls: ['./handspray-visit.component.scss']
})
export class HandsprayVisitComponent implements OnInit {

  modalRef: BsModalRef;

  visit: HandsprayVisitDetail;

  constructor(
    private location: Location,
    private modalService: BsModalService,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.data.subscribe((data: Data) => {
      this.visit = data.visit;
    })
  }

  onBack() {
    this.location.back();
  }

  onShowImage(photo: string) {
    this.modalService.show(ImageModalComponent, { initialState: { url: this.photoUri(photo) } });
  }

  onShowGps() {
    this.modalService.show(VisitGpsModalComponent, { class: 'modal-lg', initialState: { coords: this.visit['gps'] } });
  }

  photoUri(photo: string) {
    return environment.baseUrl + 'public/visit/photo?v=' + this.visit.id + '&i=' + photo;
  }
}
